import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import fetch from '../../utils/fetch';
import icons from '../../utils/icons.json';
import _ from 'lodash';
import { Link, useNavigate } from 'react-router-dom';
import ProductSlider from '../Products/ProductSlider';
import Loading from '../../components/Loading';
import { addSubProduct } from '../../store/subProducts';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import { imageurl, removeFromStore } from '../../utils/fn';
import constants from '../../utils/constants.json';
import { setRecentlyViewed } from '../../store/recentlyViewed';
import { setAlert } from '../../store/alert';
import getBrowserFingerprint from 'get-browser-fingerprint';
import banner_1 from '../../assets/banners/banner_1.png';
import banner_3 from '../../assets/banners/banner_3.png';
import { Recordsitevisiturl } from '../../utils/chaturls';
import axios from 'axios';
import { BoltOutlined } from '@mui/icons-material';
import Countdown from 'react-countdown';
import Categoriesslider from './categoriesslider';
import Onofferslider from './onofferslider';
import { isMobile } from 'react-device-detect';

function Home({ match }) {
	const fingerprint = getBrowserFingerprint();
	const dispatch = useDispatch();
	const navigate = useNavigate()

	const now = new Date();
	const midnight = new Date(now);
	midnight.setHours(24, 0, 0, 0); // Set to 00:00:00 of the current day
	const diff = midnight - now;

	const sliders = useSelector((state) => state.webSettings.data.WEB_SITE_SLIDERS);
	const categories = useSelector((state) => state.categories.data);
	const subProducts = useSelector((state) => state.subProducts.data);
	const recentlyViewed = useSelector((state) => state.recentlyViewed.data);
	const webSettings = useSelector((state) => state.webSettings.data);
	const [conditions, setconditions] = useState([]);

	const fullName = webSettings.FULL_NAME;
	const sitename = fullName?.split(' ')[0];

	const [topSellingProducts, settopSellingProducts] = useState([]);


	const [categoriesGroups, setCategoriesGroups] = useState([]);
	const [categoriesToView, setCategoriesToView] = useState([]);
	const [categoriesPos, setCategoriesPos] = useState(0);
	const [bannerPos, setBannerPos] = useState(1);
	const [maxdiscount, setmaxdiscount] = useState(0);

	useDocumentTitle(webSettings.FULL_NAME);

	const [subProductsLoading, setSubProductsLoading] = useState(false);
	const [subProductsLoadingError, setSubProductsLoadingError] = useState('');

	useEffect(() => {
		recordsitevisit()
		loadSubProducts();
		window.scroll({ top: 0, behaviour: 'smooth' });
		filtercategories()
	}, []);

	const recordsitevisit = () => {
		axios.post(Recordsitevisiturl, { fingerprint: fingerprint })
	}


	useEffect(() => {
		if (subProducts) {
			setBannerPos(Math.floor(subProducts.length / 2) - 1);
		}
	}, [subProducts]);

	useEffect(() => {
		if (categories) {
			if (categories.length > 11) {
				setCategoriesGroups(_.chunk(categories, 10));
			} else {
				setCategoriesGroups([categories]);
			}
		}
	}, [categories]);

	useEffect(() => {
		loadtopselling()
		if (categoriesGroups.length > 0) {
			setCategoriesToView(categoriesGroups[categoriesPos]);
		}
	}, [categoriesGroups, categoriesPos]);

	const filtercategories = async () => {
		const distinctarray = []
		try {
			const promises = categories.map(async (category) => {
				const res = await fetch.get('getProductsGroup', { group_code: category.item_group });
				const filterlist = res.list?.categories.filter((minicategory) => minicategory?.categoryCode !== 'GEN');
				return filterlist.map((element) => ({ ...element, item_group: category.item_group }));
			});

			const results = await Promise.all(promises);
			const finalconditions = results.flat(); // Combine all results into a single array
			//get distinct
			finalconditions.map((val, key) => {
				const categoryindex = distinctarray.findIndex((obj) => obj.categoryName == val.categoryName)
				if (categoryindex < 0) {
					distinctarray.push(val)
				}
			})
			setconditions(distinctarray);
		} catch (error) {
			// Handle errors here
			console.error('An error occurred:', error);
		}
	};

	// Renderer callback with condition
	const renderer = ({ hours, minutes, seconds, completed }) => {
		if (completed) {
			// Render a completed state
			return <Completionist />;
		} else {
			// Render a countdown
			return <span> {hours}h :{minutes}m :{seconds}s</span>;
		}
	};

	function loadSubProducts() {
		if (subProducts.length > 0) return;
		setSubProductsLoading(true);
		fetch
			.get('itemsandgroupscarousel')
			.then((res) => {
				setSubProductsLoading(false);
				dispatch(addSubProduct(res.list));

			})
			.catch((err) => {
				setSubProductsLoadingError(err.message);
				setSubProductsLoading(false);
				dispatch(setAlert({ type: 'error', message: 'Failed to get products. ' + err.message }));
			});
	}

	//fetch top selling products
	function loadtopselling() {
		fetch
			.get('getTodaysDeals')
			.then((res) => {
				if (res.list.length > 0) {
					gethighestpercentage(res.list)
					settopSellingProducts(res.list)
				} else {
					fetch
						.get('getTopSellingProducts')
						.then((res) => {
							gethighestpercentage(res.list)
							settopSellingProducts(res.list)
						})
				}
			})
	}

	function clearRecentlyViewed() {
		dispatch(setRecentlyViewed(null));
		removeFromStore(constants.RECENTLY_VIEWED);
		dispatch(setAlert({ type: 'success', message: 'Recently viewed cleared' }));
	}

	// Get highest percentage
	const gethighestpercentage = (array) => {
		if (array?.length > 0) {
			array.forEach(element => {
				element.discount = element?.amount_value ? Math.round(((parseFloat(element?.amount_value) - parseFloat(element.promotion_price)) / parseFloat(element?.amount_value)) * 100) : 0
			});

			const highestPercentage = Math.max(...array.map(o => o.discount));
			setmaxdiscount(highestPercentage);
		} else {
			setmaxdiscount(10)
		}

	};



	return (
		<div className="main-body home-body">
			<div className="min-body sections">
				<div className="categories">
					<ul>
						<p>Categories</p>
						{categoriesToView.length > 0 &&
							categoriesToView.map((data, index) => (
								<Link to={`/categories/${data.item_group}`} key={data.item_group + index}>
									<li key={index}>
										{_.startCase(data.group_name)}
										{data.subgroups.length > 0 && (
											<>
												<span dangerouslySetInnerHTML={{ __html: icons.angle_right }}></span>
												<ul>
													<p>{_.startCase(data.group_name)}</p>
													{data.subgroups.map((sub_group, index) => (
														<Link to={`/categories/${data.item_group}/${sub_group.sub_group}`} key={data.item_group + sub_group.sub_group + index}>
															<li key={index}>
																{_.startCase(sub_group.sub_group_name)}
																{data.categories.filter((sub) => sub.sub_group == sub_group.sub_group).length > 0 && (
																	<>
																		<span dangerouslySetInnerHTML={{ __html: icons.angle_right }}></span>
																		<ul>
																			<p>{_.startCase(sub_group.sub_group_name)}</p>
																			{data.categories
																				.filter((sub) => sub.sub_group == sub_group.sub_group)
																				.map((each, index) => (
																					<Link
																						to={`/categories/${data.item_group}/${sub_group.sub_group}/${each.categoryCode}`}
																						key={sub_group.sub_group + each.categoryCode + index}
																					>
																						<li key={index}>{_.startCase(each.categoryName)}</li>
																					</Link>
																				))}
																		</ul>
																	</>
																)}
															</li>
														</Link>
													))}
												</ul>
											</>
										)}
									</li>
								</Link>
							))}
					</ul>
					{categoriesGroups.length > 1 && (
						<section className="categories-footer">
							<button
								onClick={(e) => {
									setCategoriesPos((prev) => {
										return prev - 1;
									});
								}}
								disabled={categoriesPos <= 0}
							>
								<span className="icon" dangerouslySetInnerHTML={{ __html: icons.angle_left }}></span>
								<span className="txt">Previous</span>
							</button>
							<button
								onClick={(e) => {
									setCategoriesPos((prev) => {
										return prev + 1;
									});
								}}
								disabled={categoriesPos + 1 >= categoriesGroups.length}
							>
								<span className="txt">Next</span>
								<span className="icon" dangerouslySetInnerHTML={{ __html: icons.angle_right }}></span>
							</button>
						</section>
					)}
				</div>
				<div className="sliding">
					<div className="slider" style={{ cursor: "pointer" }}>
						{sliders.map((slider, index) => (
							<section onClick={() => slider.linkCode && navigate(slider.linkCode)} key={slider.imageName + index} className={'slide slide-' + (index + 1)} style={{ backgroundImage: `url(${encodeURI(imageurl(slider.imageName))})` }}></section>
						))}
						{sliders.length < 4 &&
							sliders
								.slice(0, 4 - sliders.length)
								.map((slider, index) => (
									<section key={slider.imageName + index} className={'slide slide-' + (index + 1)} style={{ backgroundImage: `url(${encodeURI(imageurl(slider.imageName))})` }}></section>
								))}
					</div>
				</div>
			</div>
			{!isMobile &&
				<div className="sections information">
					<div className="each flex">
						<span className="icon flex" dangerouslySetInnerHTML={{ __html: icons.people_carry }}></span>
						<section className="info">
							<h3 className="sub-title">Fast Delivery</h3>
							<p className="desc">No delay fast Deliveries</p>
						</section>
					</div>
					<div className="each flex">
						<span className="icon flex" dangerouslySetInnerHTML={{ __html: icons.sync }}></span>
						<section className="info">
							<h3 className="sub-title">Easy Returns</h3>
							<p className="desc">If goods have problems</p>
						</section>
					</div>
					<div className="each flex">
						<span className="icon flex" dangerouslySetInnerHTML={{ __html: icons.card }}></span>
						<section className="info">
							<h3 className="sub-title">Secure Payment</h3>
							<p className="desc">100% secure payment</p>
						</section>
					</div>
					<div className="each flex">
						<span className="icon flex" dangerouslySetInnerHTML={{ __html: icons.comments }}></span>
						<section className="info">
							<h3 className="sub-title">24/7 Support</h3>
							<p className="desc">Dedicated support</p>
						</section>
					</div>
				</div>}
			<div className="sections">
				<section className="title">
					<h3>Recently Viewed</h3>
					{recentlyViewed && recentlyViewed.length > 0 && <button onClick={clearRecentlyViewed} className="link-btn" type="button" dangerouslySetInnerHTML={{ __html: 'Clear' + icons.trash }} />}
				</section>
				{!recentlyViewed && <p style={{ padding: '20px 10px' }}>Products you viewed recently will be displayed here.</p>}
				{recentlyViewed && recentlyViewed.length > 0 && <ProductSlider data={recentlyViewed} />}
			</div>
			<div className='wrapcategoriesslider'>
				<Categoriesslider categories={categoriesToView} />
			</div>

			{topSellingProducts &&
				<div className="sections">
					<section className="title">
						<h3 style={{ display: "flex", fontSize: isMobile ? 15 : 18 }}><BoltOutlined /> Flash sales</h3>
						<div style={{ display: "flex", fontSize: 15, justifyContent: "center", alignItems: "center" }}>
							Time Left: &nbsp;
							<div style={{ fontWeight: "bold", fontSize: isMobile ? 12 : 14 }}>
								<Countdown
									date={Date.now() + diff}
									renderer={renderer}
								/>
							</div>
						</div>
						<Link to={`/todays-deals`} className="link-btn" dangerouslySetInnerHTML={{ __html: 'View All ' + icons.angle_right }} />
					</section>
					<ProductSlider data={topSellingProducts} showquantity={true} />
				</div>
			}
			{!isMobile && <div className="banner" onClick={() => navigate('/todays-deals')}>
				<div className='discountpercentage'>
					<div>GET UP TO - </div>
					<h3>{maxdiscount}%</h3>
				</div>
				<div className='discounttext'>
					Get sales upto {maxdiscount}% off when<br />
					you buy with us. We offer the <br />
					best sales offer in the market
				</div>
			</div>}
			{subProductsLoading && (
				<div className="sections">
					<Loading />
				</div>
			)}
			{subProducts.length > 0 &&
				subProducts.map((data, index) => (
					<>
						<div className="sections" key={data.group_name + index}>
							<section className="title">
								<h3>{_.startCase(_.lowerCase(data.group_name))}</h3>
								<Link to={`/categories/${data.item_group}`} className="link-btn" dangerouslySetInnerHTML={{ __html: 'View All ' + icons.angle_right }} />
							</section>
							<ProductSlider data={data.items} />
						</div>
						{/* {bannerPos == index && <div className="banner" onClick={() => navigate('/products-and-services')} style={{ backgroundImage: `url(${banner_3})` }}></div>} */}
					</>
				))}
			{!isMobile && <Onofferslider products={topSellingProducts} sitename={sitename} banner_1={banner_1} />}
			{!isMobile && <div className="sections">
				<div className='homeabout'>
					<h4>{fullName} - Unveiling Our Leading E-Commerce Website</h4>
					<h4>Welcome to the ultimate online shopping destination!</h4>
					<p>
						Our e-commerce platform is here to revolutionize your shopping journey.
						We're not just an ordinary online store; we're your digital shopping
						haven. Bid farewell to crowded malls and say hello to the convenience
						and ease of buying online in {webSettings.locations?.map((val) => _.startCase(_.lowerCase(val.locationName))).join(', ')}
						{' '}and all across Kenya.</p>

					<h4>Best Prices, Premium Brands, and Diverse Categories</h4>
					<p>Our commitment is to provide you with unbeatable prices,
						ensuring you get the most value for your money when you buy online.
						Explore a vast array of categories, encompassing{' '}
						{categories?.map((val) => val.group_name).join(', ')} and many more</p>

					<h4>Tempting Offers, Exclusive Promotions, and Enormous Savings</h4>
					<p>
						Get ready to be enchanted by our tempting offers, exclusive promotions, and substantial discounts
						when you buy online. Our online store is your gateway to unparalleled stock clearance sales. From
						lightning-quick flash sales to the grandeur of Black Friday, we ensure that your online shopping
						experience is not only cost-effective but also exhilarating. Save on an extensive range of products,
						from {conditions?.map((val) => val.categoryName).join(', ')} and many more.
					</p>

					<h4>Exceptional Services</h4>
					<p>
						At our online store, we go the extra mile to ensure your online shopping experience is seamless
						and gratifying. Benefit from our delivery service, bringing your purchases directly to your
						doorstep, making your experience utterly hassle-free. What's more, we offer a wide range of
						products with free delivery & shipping, making your shopping even more convenient and economical.
						So, browse our selection and enjoy the added benefit of no shipping charges on these items.
						Shop with confidence in our official stores, where authenticity is guaranteed.</p>
					<br />
					<p>At {fullName}, we've brought the entire shopping universe right to your fingertips.
						We're not just an online store; we're your ally in discovering the finest online sales, premium offers,
						captivating deals, and unparalleled discounts. Shop with us today and embrace the future of online
						shopping!</p>
					<br />
					<h4>FAQs</h4>
					<h5>1. How can I place an order?</h5>
					<p>Placing an order is easy! Simply browse our website, select the products you want, add them to your cart, and proceed to checkout. Follow the on-screen instructions to complete your purchase.</p>
					<br />
					<h5>2. What payment methods do you accept?</h5>
					<p>We accept a variety of payment methods, including credit cards and cash on delivery. Choose the one that suits you best during the checkout process.</p>
					<br />
					<h5>3. How long does delivery take?</h5>
					<p>Delivery times may vary depending on your location and the product. We strive to deliver your orders as quickly as possible, and you can check the estimated delivery time during the checkout process.</p>
					<br />
					<h5>4. Do you offer refunds or returns?</h5>
					<p>Yes, we have a hassle-free return and refund policy. If you're not satisfied with your purchase, you can initiate a return request, and we'll guide you through the process.</p>
					<br />
					<h5>5. Is my personal information safe?</h5>
					<p>Absolutely. We take data security seriously and have robust measures in place to protect your personal information. Your data is safe with us.</p>
				</div>

			</div>}
		</div>
	);
}

export default React.memo(Home);
